import React, { useEffect } from 'react'
import './App.scss';
import RouteComponent from "./routes/route"
import { RootState } from './store/reducers';
import Alert from './components/Alert';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../src/store";
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import i18n from './i18n'
import { getCookie } from "../src/helper/cookieFunction";


export default function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.auth);
  const { shopUrlState } = bindActionCreators(actionCreators, dispatch);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const getShopUrl = () => {
   
    if (true) {
      shopUrlState(getCookie(`redirect`))
      navigate("/login")
    } else {
      // console.log("else")
    }
  }

  useEffect(() => {
    getShopUrl();
  }, []);


  useEffect(() => {
    const onLanguageHandle = () => {
      i18n.changeLanguage(state.langValue);
      localStorage.setItem("Language", JSON.stringify(state.langValue));
    };
    onLanguageHandle();
  }, [state.langValue]);

  return (
    <div className="App">
      {state.alert.show && <Alert />}
      <RouteComponent />
    </div>
  );
}
